<template>
    <div id="site-app">
        <NavMenu v-if="navVisible" />
        <router-view></router-view>

        <LoginModal 
            class="font-artlist" 
            v-if="$store.state.openSignInModal"
            :social-error="socialError" />

        <SignUpModal 
            class="font-artlist" 
            v-if="$store.state.openSignUpModal"
            :social-error="socialError" />
    </div>
</template>

<script>
import NavMenu from './components/NavMenu'
import analyticsEvents from './utils/analyticsEvents';
import LoginModal from '@/components/LoginModal'
import SignUpModal from '@/components/SignUpModal'
import { eventTracker } from "./utils/eventTracker";
import { setBaseSuperProperties, setMixpanelSuperProperties } from "../new-site-app/utils/eventSuperProperties";
import { updateUserInfo } from "../new-site-app/utils/eventTracker";

export default {
    components: {
        NavMenu,
        LoginModal,
        SignUpModal,
    },
    data() {
        return {
            socialError: '',
        };
    },
    beforeMount() {
      window.__mixpanel__ = this.$mixpanel;
      window.__analyticsEvents__ = analyticsEvents;

      setBaseSuperProperties();
      setMixpanelSuperProperties(this.$mixpanel);
    },

    mounted() {
      const notFirstTimeSession = window.localStorage.getItem('notFirstTimeSession');
      if (!notFirstTimeSession) {
        window.localStorage.setItem('notFirstTimeSession', '1');
        eventTracker(analyticsEvents.firstTimeVisit);
      }

      updateUserInfo()
      this.socialErrorHandle();
      sessionStorage.removeItem('redirectTo');
    },

    computed: {
        navVisible() {
            return !this.$route.name || !this.$route.name.includes("team_invite");
        }
    },
       methods:{
        socialErrorHandle() {
            const urlParams = new URLSearchParams(window.location.search);
            const isSignUpError = urlParams.get('social_signup_error');
            const isLoginError = urlParams.get('social_login_error');
            const msg = urlParams.get('error_message');
            let modalType = '';
            let clickSource = '';
            if (isSignUpError) {
                modalType = 'setOpenSignUpModal';
                clickSource = 'sign up popup';
            }
            if (isLoginError) {
                modalType = 'setOpenSignInModal';
                clickSource = 'sign in popup';
            }
            if ((isSignUpError || isLoginError) && msg) {
                this.openModal(modalType, clickSource);
                this.$nextTick(() => {
                this.socialError = msg;
                });
            }
        },
        openModal(modalType, clickSource) {
            this.$store.dispatch(modalType, { open: true, clickSource });
        },
    },
}
</script>

<style scoped>
.font-artlist {
    font-family: "Artlist Sans";
    line-height: 1.5;
    letter-spacing: 0.2px;
}
</style>
